import React from "react";
import { FormGroup, ControlLabel, Checkbox, Dropdown, MenuItem } from "react-bootstrap";
import locale from "../../../../../locale";
import FormControlLanguage from "../../../../UI/FormControlLanguage";

const timeoutFormatList = ["dd_hh_mm", "dd_hh_mm_ss"];

export default ({ blockProperties, onUpdateBlockProperties, onSave }) => {
    return (
        <>
            <FormGroup>
                <ControlLabel>{locale('settings.title')}</ControlLabel>
                <Checkbox
                    style={{marginTop: 0}}
                    checked={blockProperties?.showTitle ?? true}
                    onChange={(e) => onSave({showTitle: e.target.checked})}
                >
                    {locale('settings.showTitle')}
                </Checkbox>
            </FormGroup>

            {
                blockProperties?.showTitle &&
                <FormGroup>
                    <FormControlLanguage
                        type="text"
                        placeholder={locale('settings.placeholder.title')}
                        values={{
                            ru: blockProperties?.titleRu || '',
                            en: blockProperties?.titleEn || '',
                        }}
                        onChange={{
                            ru: (e) => onUpdateBlockProperties({titleRu: e.target.value}),
                            en: (e) => onUpdateBlockProperties({titleEn: e.target.value}),
                        }}
                        onBlur={() => onSave({
                            titleRu: blockProperties.titleRu,
                            titleEn: blockProperties.titleEn,
                        })}
                    />
                </FormGroup>
            }

            <FormGroup>
                <ControlLabel style={{ width: '100%' }}>{locale('settings.timeoutFormat')}</ControlLabel>
                <Dropdown id="timeoutFormat" style={{ marginBottom: '20px' }}>
                    <Dropdown.Toggle>
                        {locale(`settings.timeoutFormat.${blockProperties?.timeoutFormat || timeoutFormatList[0]}`)}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        {
                            timeoutFormatList.map((item) => (
                                <MenuItem
                                    key={item}
                                    onClick={() => onSave({ timeoutFormat: item })}
                                >
                                    {locale(`settings.timeoutFormat.${item}`)}
                                </MenuItem>
                            ))
                        }
                    </Dropdown.Menu>
                </Dropdown>

                <Checkbox
                    style={{marginTop: 0}}
                    checked={!blockProperties?.emptyVisibleDay}
                    onChange={(e) => onSave({emptyVisibleDay: !e.target.checked})}
                >
                    {locale('settings.timeoutFormat.emptyVisibleDay')}
                </Checkbox>
            </FormGroup>
        </>
    )
};
